<template>
  <div id="app">
    <router-view></router-view>
    <footers></footers>
  </div>
</template>

<script>
import Footers from './components/Footers'

export default {
    name: 'App',
    components: {
      Footers
    },
    metaInfo: { 
      titleTemplate: 'Koios Analytics %s'
    },
}
</script>
